export const SWITCH_TICKET_MESSAGES_MAP = {
  SWITCHING_FROM_PAID_TO_FREE: 'paid-to-free',
  SWITCHING_FROM_FREE_TO_PAID: 'free-to-paid',
  SWITCHING_FROM_PAID_TO_PAID: 'paid-to-paid',
};
